export default "__VITE_ASSET__CTMRVhMX__"